import MiniHeroSection from "../components/MiniHeroSection";
import { useState } from "react";
import useSWR from "swr";
import { secureFetcher, SECURITY_CONFIG } from "../config/security";
import SecondHeading from "../components/SecondHeading";
import WelcomeHeading from "../components/calculator/WelcomeHeading";
import ComponentEstimateCard from "../components/calculator/ComponentEstimateCard";
import CloudPricingCalculator from "../components/calculator/CloudPricingCalculator";

const PriceCalculator = () => {
  // Variable ka naam change kar ke 'pageData' rakha hai taake component name se clash na ho
  const {
    data: pageData,
    error,
    isLoading,
  } = useSWR(
    `${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.WP_PAGES_ENDPOINT}/1134`,
    secureFetcher,
  );

  const [selectedItems, setSelectedItems] = useState([]);
  const [stateName, setStateName] = useState("welcome_heading");

  const handleNextStep = (selectedItems) => {
    console.log("User selected these services: ", selectedItems);
    setSelectedItems(selectedItems);
    setStateName("cloud_pricing");
  };

  // 1. Agar API load ho rahi hai, toh loader dikhao
  if (isLoading) {
    return (
      <div className="text-center p-5 mt-5">
        <div
          className="spinner-border"
          style={{ color: "#3db4e5" }}
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // 2. Agar API fail ho jaye
  if (error || !pageData) {
    return (
      <div className="alert alert-danger text-center mt-5">
        Failed to load page data. Please refresh or try again later.
      </div>
    );
  }

  // 3. Jab data mil jaye, tab render karein
  return (
    <div className="price-calculator">
      {/* Hero Section - Data load hone ke baad hi chalega */}
      <MiniHeroSection
        data={pageData.acf?.hero_banner}
        className="centered-content"
      />

      <SecondHeading
        data={{
          heading: pageData.acf?.second_heading,
          paragraph: pageData.acf?.second_heading_below,
        }}
      />

      {/* State wise components */}
      {stateName === "welcome_heading" && (
        <WelcomeHeading content={pageData.acf} setStateName={setStateName} />
      )}

      {stateName === "component_catalog" && (
        <ComponentEstimateCard onNext={handleNextStep} />
      )}

      {stateName === "cloud_pricing" && (
        <CloudPricingCalculator preSelectedItems={selectedItems} />
      )}
    </div>
  );
};

export default PriceCalculator;
